/* @flow */
import * as React from 'react';
import { useDispatch } from 'react-redux';

import styles from './BraindateParticipantsListItem.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { fetchUser } from 'src/shared/domain/user/action/userActions';
import { getUserId } from '@braindate/domain/lib/user/util';
import { fetchUserTopics } from 'src/shared/domain/topic/action/topicActions';

// Hooks
import useEventId from 'src/shared/domain/event/hook/useEventId';

// Components
import BraindateParticipantsItem from './elements/BraindateParticipantsItem';

// Types
import type { User } from '@braindate/domain/lib/user/type';
import type { BraindateParticipantListElement } from './BraindateParticipants';

const useStyles = createUseThemeStyles(styles);

type Props = {
  participant: User,
  columns: BraindateParticipantListElement[],
  onClose: () => void,
};

const BraindateParticipantsListItem = ({
  participant,
  columns,
  onClose,
}: Props) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const eventId = useEventId();

  React.useEffect(() => {
    dispatch(fetchUserTopics(eventId, getUserId(participant), { limit: 1 }));
    dispatch(fetchUser(getUserId(participant), eventId));
  }, []);

  return (
    <div className={classes.root} key={`participant-${getUserId(participant)}`}>
      {columns.map((column, key) => (
        <BraindateParticipantsItem
          column={column}
          participant={participant}
          onClose={onClose}
          render={(child) => (
            <div key={`participant-${getUserId(participant)}-${key}`}>
              {child}
            </div>
          )}
          key={`participant-${getUserId(participant)}-${key}`}
        />
      ))}
    </div>
  );
};

export default React.memo<Props>(BraindateParticipantsListItem);
